// Dependencies
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';

// Google Material design
import 'react-mdl/extra/material.css';
import 'react-mdl/extra/material.js';

// Components
import App from './components/app';
import Home from './components/home';
import Ladder from './components/ladder';
import ArchivedLadder from './components/archived-ladder';

ReactDOM.render((
    <Router history={browserHistory}>
        <Route path="/" component={App}>
        <IndexRoute component={Home}/>
        <Route path="/:mode/:class" component={Ladder}/>
        <Route path="archived-ladder/:id/:mode" component={ArchivedLadder}/>
        </Route>
    </Router>
), document.getElementById('root'))



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/